export default function dt_gb_filters_smart_head_append(customclass, css) {

	var searchForStyleEle = jQuery('head').find('#' + customclass);

	if (searchForStyleEle.length <= 0) {
		jQuery('head').append(css);
	}

}